import Cookie from 'js-cookie';
import { CookieName } from './constants';
var getLangPreferenceCookie = function getLangPreferenceCookie() {
  return Cookie.get(CookieName.LANG_PREFERENCE);
};
export default getLangPreferenceCookie;